import { jsx as I, jsxs as Ce } from "react/jsx-runtime";
import { ModuleRegistry as at } from "ag-grid-community";
import { AllEnterpriseModule as ct, LicenseManager as lt } from "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact as it } from "ag-grid-react";
import ve from "classnames";
import { merge as _t, cloneDeep as Te, isNumber as dt } from "lodash";
import { noop as p } from "lodash/fp";
import pt, { useMemo as u, useRef as L, useState as $, useCallback as a } from "react";
import { DEFAULT_FEATURES_STATE as ut, ROW_HEIGHTS as Oe, DEFAULT_NUMERIC_CONFIGURATIONS as Ie, CUSTOM_CELLS_DEFAULT_PINNED_LEFT as ft, CUSTOM_CELLS_DEFAULT_PINNED_RIGHT as mt, DEFAULT_NO_RESULTS as J, CUSTOM_CELLS_THAT_NOT_OPEN_DRAWER as ht, HEADER_HEIGHTS as gt } from "./index.es594.js";
/* empty css            */
import { useKeyboardNavigationDetected as wt } from "@placer-ui/hooks";
import { DataGridContextProvider as bt } from "./index.es596.js";
import { createDataGridState as Dt } from "./index.es597.js";
import { useTheme as Et } from "./index.es190.js";
import { generatePlaceholderRows as Ct } from "./index.es598.js";
import { generateColDefs as vt } from "./index.es599.js";
import { useCustomIcons as Tt } from "./index.es600.js";
import { NoRowsComponent as Ot } from "./index.es601.js";
import { getOverrideTableComponents as It } from "./index.es602.js";
import { getRowClass as Lt } from "./index.es603.js";
import { Blur as Mt } from "./index.es163.js";
import { ActionToolbar as At } from "./index.es604.js";
import { DrawerTemplate as Gt } from "./index.es122.js";
import { onKeyDownEnterAndSpace as Rt } from "./index.es526.js";
at.registerModules([ct]);
lt.setLicenseKey("Using_this_{AG_Grid}_Enterprise_key_{AG-071146}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Placer_Labs_Inc.}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Placer_Dashboard}_only_for_{8}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{Placer_Dashboard}_need_to_be_licensed___{Placer_Dashboard}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{7_December_2025}____[v3]_[01]_MTc2NTA2NTYwMDAwMA==4325edb56e79a73cba5587d7af29671a");
const Nt = [], Ut = [];
function yt({
  columns: f,
  excludedColumnsFromSelection: M,
  quickFilterText: z,
  isDataFiltered: Q,
  tableContainerHeight: A,
  cornerRadius: m,
  overrideNoResult: G,
  blur: Le,
  loading: i,
  alwaysShowColumnsDivider: Y = !0,
  disableColumnsDrag: Me = !1,
  disableContextMenu: Ae = !0,
  maxRowSelection: w,
  rowData: W = Ut,
  loadingRows: R = Nt,
  testId: h = "data-grid",
  rowSelection: Ge = "multiple",
  gridDensity: n = "standard",
  columnSelectionType: N = "off",
  features: g = ut,
  numericConfigurations: U = Ie,
  defaultPinnedColumnsLeft: V = ft,
  defaultPinnedColumnsRight: X = mt,
  maxRowSelectedCallBack: y = p,
  getGridApi: Z = p,
  onRowsSelected: q = p,
  onColumnSelect: ee = p,
  onCellValueChanged: Re = p,
  onRowDragEnd: Ne = p,
  onRowClicked: te = p,
  onCellClicked: re = p,
  onCellKeyDown: S = p,
  onGridReady: oe = p,
  onResetFilters: C,
  getRowId: Ue,
  dataGridInitialState: se,
  ...ye
}) {
  var Ee;
  const Se = wt(), _ = u(() => se ?? Dt(), [se]), k = L(), ne = L(), H = L(null), [o, ke] = $(), ae = L([]), [v, B] = $(!1), [P, He] = $([]), [K, ce] = $(void 0), l = L(null), { cornerRadius: Pe } = Et(), { pagination: xe, bulkEditable: j, filter: b, drawer: c, ...Fe } = g, {
    editable: le,
    resizable: ie,
    checkboxSelection: _e,
    headerCheckboxSelection: de,
    rowDrag: pe,
    sortable: ue,
    wrapHeaderText: fe,
    wrapText: me,
    filterParams: he
  } = Fe, { isOpeningManualHandled: D, ...$e } = c || {}, T = m ? Pe[m] : void 0, ze = u(() => {
    var e;
    return i && W.length === 0 ? Ct(
      f,
      n,
      A ?? ((e = H.current) == null ? void 0 : e.clientHeight)
    ) : W;
  }, [i, W, f, n, A]), We = u(() => {
    const e = {
      "--ag-header-column-separator-width": "2px",
      "--ag-header-column-separator-height": "30%",
      "--ag-header-column-separator-color": "var(--plac-lines-default)",
      "--ag-header-column-separator-display": "flex"
    }, t = {
      "--ag-row-height": `${Oe[n]}px`,
      "--ag-wrapper-border-radius": m ? T : "0px",
      height: A
    };
    return !g.resizable && Y ? { ...t, ...e } : t;
  }, [
    n,
    m,
    T,
    A,
    g.resizable,
    Y
  ]), Be = u(
    () => ve("pl-ag-container", {
      hasCornerRadius: !!m,
      loading: !!i
    }),
    [m, i]
  ), Ke = u(() => ve("data-grid", n), [n]), ge = u(
    () => N !== "off" && !b,
    [N, b]
  ), je = u(() => {
    const e = {
      columns: f,
      gridDensity: n,
      numericConfigurations: U,
      selectedColumn: P,
      filter: b,
      testId: h,
      loadingRows: R,
      loading: i
    };
    if (!l.current || l.current.columns !== f || l.current.gridDensity !== n || l.current.numericConfigurations !== U || l.current.selectedColumn !== P || l.current.filter !== b || l.current.testId !== h || l.current.loadingRows !== R || l.current.loading !== i) {
      const r = {
        filter: b,
        editable: le,
        resizable: ie,
        checkboxSelection: _e,
        headerCheckboxSelection: de,
        rowDrag: pe,
        sortable: ue,
        wrapHeaderText: fe,
        wrapText: me,
        propsToDrill: { gridDensity: n, testId: h },
        numericConfigurations: {
          ...Ie,
          ...U
        },
        loadingRows: R,
        loading: i,
        filterParams: he
      };
      ae.current = vt(
        f,
        _,
        r,
        P,
        V,
        X
      ), l.current = e;
    }
    return ae.current;
  }, [
    f,
    n,
    U,
    P,
    b,
    h,
    he,
    R,
    i,
    le,
    ie,
    _e,
    de,
    pe,
    ue,
    fe,
    me,
    V,
    X,
    _
  ]), Je = Tt();
  pt.useEffect(() => () => {
    l.current = null;
  }, []);
  const Qe = u(() => {
    const t = z || Q ? "filter" : "default", r = J[t].testId, s = {
      ...J,
      filter: {
        ...J.filter,
        buttonText: C ? "Reset Filters" : void 0,
        onButtonClick: () => C == null ? void 0 : C()
      }
    }, E = _t(
      Te(s[t]),
      Te(G == null ? void 0 : G[t])
    );
    return () => /* @__PURE__ */ I(Ot, { ...E, testId: r });
  }, [Q, z, C, G]), Ye = a(
    (e) => {
      if (!o) return;
      const t = o.getSelectedNodes().filter((s) => dt(s.rowIndex)).map((s) => s.rowIndex);
      _.setSelectedRowIndices(t);
      const r = o.getSelectedNodes().map((s) => s.data);
      !w || w && r.length <= w ? (q(r), r != null && r.length ? ce(r.length) : ce(void 0)) : w && r.length > w && (e.node.setSelected(!1), y == null || y());
    },
    [o, y, w, q, _]
  ), Ve = a(
    (e) => {
      const r = e.column.getColDef().field;
      ge && r && !(M != null && M.includes(r)) && He((E) => {
        let d = [...E];
        return N === "single" ? d = [r] : d.includes(r) ? d = d.filter((nt) => nt !== r) : d.push(r), ee(d), d;
      });
    },
    [
      N,
      M,
      ge,
      ee
    ]
  ), x = a(
    (e, t, r) => {
      var s;
      c && (r && D || (g.editable ? console.warn("DataGrid: Editable Cells Do not work with drawer") : (B(!0), (s = c.onOpenedBy) == null || s.call(c, e, t), ne.current = t)));
    },
    [c, g.editable, D]
  ), F = a(() => {
    B(!1);
  }, []), we = a(() => v, [v]), be = a(
    (e, t) => {
      c && (!g.editable && !D ? e === ne.current && v && c.isClosingByClickOfSameRow ? F() : x(t, e, !0) : console.warn(
        D ? "DataGrid: Manual Drawer Mode is Enabled" : "DataGrid: Editable Cells Do not work with drawer"
      ));
    },
    [c, g.editable, D, v, F, x]
  ), O = a(
    (e) => {
      var d;
      const t = e.rowIndex, r = e.data, s = e.column.getId(), E = e.colDef.type || "";
      k.current = { rowIndex: t, colKey: s }, E === "action" && ((d = e.event) == null || d.preventDefault()), ht.includes(E) || be(t, r), re(e);
    },
    [be, re]
  ), Xe = a(
    (e) => {
      Rt(e.event, () => O == null ? void 0 : O(e)), S == null || S(e);
    },
    [O, S]
  ), Ze = a(
    (e) => {
      const t = e.api;
      t.openDrawer = (r, s) => x(r, s, !1), t.closeDrawer = F, t.isDrawerOpen = we, oe(e), ke(t), Z(t), t.addEventListener("cellMouseOver", (r) => {
        _.hoveredRowIndex.set(r.node.sourceRowIndex ?? -1);
      }), t.addEventListener("cellMouseOut", () => {
        _.hoveredRowIndex.set(-1);
      });
    },
    [Z, x, F, we, oe, _]
  ), qe = a((e) => {
    e.api.refreshHeader();
  }, []), et = a(() => {
    if (i) return;
    (o == null ? void 0 : o.getDisplayedRowCount()) ? o == null || o.hideOverlay() : o == null || o.showNoRowsOverlay();
  }, [o, i]), tt = u(
    () => It({ gridDensity: n }),
    [n]
  ), rt = a(
    (e) => Lt(e, f, _),
    [f, _]
  );
  let De;
  c && D && (De = c.triggerRef);
  const ot = a(
    (e) => {
      var t, r;
      B(e), e === !1 && k.current && (o == null || o.setFocusedCell(
        (t = k.current) == null ? void 0 : t.rowIndex,
        (r = k.current) == null ? void 0 : r.colKey
      ));
    },
    [o]
  ), st = a(
    (e) => {
      var t;
      if ((t = e.event) != null && t.defaultPrevented)
        return null;
      te(e);
    },
    [te]
  );
  return /* @__PURE__ */ Ce(bt, { dataGridState: _, children: [
    /* @__PURE__ */ I(
      Mt,
      {
        isActive: !!Le,
        variant: "overlay",
        testId: `${h}-blur`,
        style: { height: "100%" },
        "aria-label": "Data Grid Blur Overlay",
        children: /* @__PURE__ */ Ce(
          "div",
          {
            className: Be,
            "data-testid": `${h}-container`,
            style: We,
            ref: H,
            children: [
              /* @__PURE__ */ I(
                it,
                {
                  animateRows: !0,
                  suppressMovableColumns: Me,
                  suppressContextMenu: Ae,
                  suppressRowClickSelection: !0,
                  suppressDragLeaveHidesColumns: !0,
                  rowDragManaged: !0,
                  stopEditingWhenCellsLoseFocus: !0,
                  rowSelection: Ge,
                  quickFilterText: z,
                  singleClickEdit: !0,
                  cacheQuickFilter: !0,
                  tooltipShowDelay: 0,
                  rowBuffer: 20,
                  tabIndex: 0,
                  theme: "legacy",
                  domLayout: "normal",
                  tooltipTrigger: Se ? "focus" : "hover",
                  rowData: ze,
                  icons: Je,
                  className: Ke,
                  columnDefs: je,
                  headerHeight: gt[n],
                  rowHeight: Oe[n],
                  components: tt,
                  onModelUpdated: et,
                  getRowClass: rt,
                  onGridReady: Ze,
                  onRowDragEnd: Ne,
                  onRowSelected: Ye,
                  onColumnHeaderClicked: Ve,
                  onFilterChanged: qe,
                  onCellValueChanged: Re,
                  getRowId: Ue,
                  noRowsOverlayComponent: Qe,
                  onCellKeyDown: Xe,
                  onRowClicked: st,
                  onCellClicked: O,
                  ...xe,
                  ...ye
                }
              ),
              j && K !== void 0 && /* @__PURE__ */ I(
                At,
                {
                  visible: j && !!K,
                  selectedCount: K,
                  testId: h + "-action-toolbar",
                  ...j
                }
              )
            ]
          }
        )
      }
    ),
    c && /* @__PURE__ */ I(
      Gt,
      {
        ...$e,
        triggerRef: De,
        setIsOpen: ot,
        isOpen: v,
        container: H.current,
        height: `${((Ee = H.current) == null ? void 0 : Ee.clientHeight) - 2}px`,
        customPosition: m ? { top: "1px", right: "1px" } : {},
        customBorderRadius: T ? `0px ${T} ${T} 0px` : void 0
      }
    )
  ] });
}
const cr = yt;
export {
  cr as DataGrid
};
//# sourceMappingURL=index.es555.js.map
